/* ═══════════════════════════════════════════════════════
   NYC Suite — Image Storage (IndexedDB)
   Stores attachment dataUrls locally so they persist
   when quotes are saved/reloaded from Firestore.
   ═══════════════════════════════════════════════════════ */

const IMG_DB_NAME = "nycap-images";

const openImgDb = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(IMG_DB_NAME, 1);
  req.onupgradeneeded = () => req.result.createObjectStore("images");
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

/** Save image dataUrls for a quote. images = [{ id, dataUrl }] */
export const saveImages = async (quoteId, images) => {
  if (!images || images.length === 0) return;
  const db = await openImgDb();
  const tx = db.transaction("images", "readwrite");
  const map = {};
  images.forEach(img => { if (img.id && img.dataUrl) map[img.id] = img.dataUrl; });
  tx.objectStore("images").put(map, quoteId);
  return new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = rej; });
};

/** Get stored image dataUrls for a quote. Returns { attachmentId: dataUrl } or null */
export const getImages = async (quoteId) => {
  const db = await openImgDb();
  const tx = db.transaction("images", "readonly");
  const req = tx.objectStore("images").get(quoteId);
  return new Promise((res) => { req.onsuccess = () => res(req.result || null); req.onerror = () => res(null); });
};

/** Delete stored images for a quote */
export const deleteImages = async (quoteId) => {
  const db = await openImgDb();
  const tx = db.transaction("images", "readwrite");
  tx.objectStore("images").delete(quoteId);
  return new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = rej; });
};
